import { inject, Injectable } from '@angular/core';
import { filter, Observable, ReplaySubject } from 'rxjs';
import { SharedCallingRoutingPolicy } from '../../../shared/models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from '../../../shared/contexts/microsoft-tenants-state.context';

@Injectable()
export class SharedCallingPoliciesContext {
  private _http = inject(HttpClient);
  private _microsoftTenantsStateContext = inject(MicrosoftTenantsStateContext);

  private _tenantId: string;
  private _stateSource = new ReplaySubject<SharedCallingRoutingPolicy[]>(1);
  state$ = this._stateSource.asObservable();

  constructor() {
    this._microsoftTenantsStateContext.cachedTenantState$
      .pipe(filter((cachedTenant) => !!cachedTenant?.tenantId))
      .subscribe((cachedTenant) => {
        this._tenantId = cachedTenant.tenantId.toString();
        this._refresh().subscribe();
      });
  }

  private _refresh(): Observable<void> {
    return this._get().pipe(map((policies) => this._stateSource.next(policies)));
  }

  private _get(): Observable<SharedCallingRoutingPolicy[]> {
    return this._http.get<SharedCallingRoutingPolicy[]>(
      `/services/microsoft/views/tenants/${this._tenantId}/shared-calling-routing-policies`,
    );
  }
}
